import { render, staticRenderFns } from "./Numeracion_agregar.vue?vue&type=template&id=0f158ca9"
import script from "./Numeracion_agregar.vue?vue&type=script&lang=js"
export * from "./Numeracion_agregar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports